<template>
  <div class="PaymentRecord">
    <el-row>
      <el-form
        :inline="true"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        @submit.native.prevent
      >
        <el-form-item label="老人姓名">
          <el-input
            v-model.trim="oldName"
            placeholder="请输入老人姓名"
            clearable
            @keyup.enter.native.prevent="enterSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="老人身份证">
          <el-input
            v-model.trim="idCard"
            placeholder="请输入老人身份证"
            clearable
            @keyup.enter.native.prevent="enterSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="账单类型">
          <el-select
            v-model="billType"
            clearable
            placeholder="请选择"
            style="width:150px"
          >
            <el-option label="入院项目确认单" value="1"></el-option>
            <el-option label="出院缴费单" value="2"></el-option>
            <el-option label="调整退费单" value="3"></el-option>
            <el-option label="月度账单" value="4"></el-option>
            <el-option label="请假退费单" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="margin-left: 30px"
            icon="el-icon-search"
            plain
            @click="queryTable"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-table
        :data="tableData"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
        style="width: 100%"
      >
        <el-table-column
          prop="billNumber"
          label="账单编号"
          min-width="140"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="oldName"
          label="老人姓名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="idCard"
          label="身份证号"
          width="190px"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="inDate"
          label="入院时间"
          align="center"
        ></el-table-column>
        <!-- <el-table-column
          prop="totalPay"
          label="账单金额"
          align="center"
        ></el-table-column> -->
        <el-table-column
          prop="billType"
          label="账单类型"
          align="center"
          :formatter="formatBillType"
        ></el-table-column>
        
        <el-table-column prop="isPay" label="是否确认" width="100px" align="center">
          <template slot-scope="scope">
            <p
              :style="'color:' + (scope.row.isPay == 0?'#ff0000':'#1395DB')"
              >{{ scope.row.isPay == 1?"已确认":"未确认" }}</p>
          </template>
        </el-table-column>
        
        <el-table-column prop="option" label="操作" width="200px" align="center">
          <template slot-scope="scope">
          
            <el-button
              style="margin-right: 5px"
              type="primary"
              size="mini"
              plain
              @click="moneyDetail(scope.row)"
              >确认</el-button
            >
            <el-button
              style="margin-right: 5px"
              type="success"
              size="mini"
              plain
              @click="jumpAdmissionDetail(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-pagination
      class="fenye"
      background
      layout="total,prev, pager, next"
      :total="total"
      @current-change="changePage"
      align="center"
    ></el-pagination>

    <!-- 信息确认单 -->
    <el-dialog
      title="费用确认单"
      :visible.sync="MoneyDialogVisible"
      width="25%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      @close="closeMoney"
    >
      <el-form label-width="100px" class="demo-ruleForm">
        <!-- 调房调级 -->
        <div v-if="billItem.billType == 3 || billItem.billType == 5">
          <p style="text-align: center; font-size: 18px">
            请确认并核对金额
          </p>
          <el-form-item label="实际金额" style="margin-top:20px">
            <el-input
              style="width: 80%"
              placeholder="请输入实际金额"
              v-model.trim="moneyFee"
              @input="inputNumChange"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </div>

        <div v-else-if="billItem.billType == 1">
          <p style="text-align: center; font-size: 18px">
            请确认并核对押金编号
          </p>
          <el-form-item label="押金编号" style="margin-top:20px">
            <el-input
              style="width: 80%"
              placeholder="请输入押金编号"
              v-model.trim="moneyId"
              onkeyup="value=value.replace(/[^\w\.\/]/ig,'')"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </div>

        <div v-else-if="billItem.billType == 4">
          <p style="text-align: center; font-size: 18px">
            请核对金额后点击确定
          </p>
          <!-- <el-form-item label="收费票据号" style="margin-top:20px" >
            <el-input
              style="width: 80%"
              placeholder="请输入收费票据号"
              v-model.trim="moneyId"
              onkeyup="value=value.replace(/[^\w\.\/]/ig,'')"
              maxlength="20"
            ></el-input>
          </el-form-item> -->
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="MoneyDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addBill">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus";
export default {
  name: "PaymentRecord",
  components: {},
  data() {
    return {
      checkBillDialogVisible: false,
      tableData: [],
      oldName: "", //搜索查询老人
      idCard: "", //搜索查询老人身份证
      MoneyDialogVisible: false, //控制押金信息弹窗
      moneyId: "",
      billId: 0, //缴费id
      //分页
      billType:"",
      total: 0,
      moneyFee:"",
      pageNum: 1,
      billItem:"",
      pageSize: 10,
      checkBill: [],
    };
  },
  methods: {
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    /* 
      enter查询
    */
    enterSearch(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.queryPayList();
      }
    },
    /* 
      搜索查询
    */
    queryTable() {
      this.queryPayList();
    },

    /* 分页 */
    changePage(val) {
      this.pageNum = val;
      this.queryPayList();
    },

    /* 
      查询缴费记录单列表
    */
    queryPayList() {
      let param = {
        oldName: this.oldName,
        idCard: this.idCard,
        billType:this.billType,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$postJson("omc/bill/queryListWithPage", param).then((res) => {
        this.total = Number(res.result.total);
        this.tableData = res.result.list;
      });
    },
    inputNumChange(val) {
      //限制输入数字和两位小数;
      this.moneyFee = val.replace(/[^0-9.]/g, '').replace(/^\D*(\d*(?:.\d{0,2})?).*$/g, '$1')
    },
    formatBillType: function (row) {
      if (row.billType == 1) {
        return "入院项目确认单";
      } else if (row.billType == 2) {
        return "出院缴费单";
      } else if (row.billType == 3) {
        return "调整退费单";
      } else if (row.billType == 4) {
        return row.monthDay + "月账单";
      } else if (row.billType == 5) {
        return "请假退费单";
      }
    },

    /* 
      押金信息
    */
    moneyDetail(row) {
      console.log(row);
      this.billItem = row;
      this.billId = Number(row.id);
      if (row.billType == 1) {
        if (row.isPay != 1) {
          this.MoneyDialogVisible = true;
          this.moneyId = "";
        }
      }
      if (row.billType == 3 && row.isPay != 1) {
        this.MoneyDialogVisible = true;
        this.moneyFee = row.totalPay;
      }
      //周期账单弹窗
      if (row.billType == 4) {
        if (row.isPay != 1) {
          this.MoneyDialogVisible = true;
          this.moneyId = "";
        }
      }
    },
    /* 
      缴费
    */
    addBill() {
      let params = {
        billId: this.billId,
        cashPledgeNum: this.moneyId,
        payFee:this.moneyFee,
      };

      this.$postJson("omc/bill/payFee", params).then((res) => {
        if (res.code == 200) {
          this.MoneyDialogVisible = false;
          this.$message({ message: res.message, type: "success" });
          this.queryPayList();
        } else {
          this.$message({ message: res.message, type: "error" });
        }
      });
    },

    //关闭缴费弹窗
    closeMoney() {
      this.moneyId = "";
    },

    /* 
      跳转入院详情
    */
    jumpAdmissionDetail(row) {
      sessionStorage.setItem("detailOldId", row.oldManId);
      sessionStorage.setItem("detailBillId", row.id);
      sessionStorage.setItem("detailSex", row.sex);
      sessionStorage.setItem("detailBillType", row.billType);
      bus.$emit("homePage", {
        type: "jump",
        path: "/admissionExpensesDetail",
        title: "费用结算详情",
      });
    },
  },
  created() {},
  mounted() {
    this.queryPayList();
    //监听 来自缴费信息录入页面
    this.$bus.$on("changeOldListStatus", () => {
      console.log("缴费记录单录入完成刷新缴费记录单");
      this.queryPayList(); //刷新缴费记录单列表的数据
    });
  },
};
</script>
<style lang="scss" scoped>
.curcor {
  font-size: 28px;
  color: rgb(1, 185, 237);
  cursor: pointer;
}
//  ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
</style>
